<template>
  <div :class="'md-layout'">
    <div :class="'md-layout-item md-size-100'">
      <md-card>
        <md-card-header :class="'md-card-header-icon md-card-header-danger'">
          <div :class="'card-icon'">
            <md-icon>assignment</md-icon>
          </div>
          <h4 :class="'title'">
            List
          </h4>
        </md-card-header>
        <md-card-content>
          <md-table v-model="logs" table-header-color="orange">
            <md-empty-state
              md-icon="list"
              md-label="Logs"
              :md-description="'No logs found' + (this.filtersQuery ? ' with the searched terms' : '')"
              v-if="!isFetching">
            </md-empty-state>
            <md-table-row slot="md-table-row" slot-scope="{ item: log }">
              <md-table-cell md-label="Action" v-html="log.action"></md-table-cell>
              <md-table-cell md-label="Date">{{ log.created_at | datetime }}</md-table-cell>
              <md-table-cell md-label="Previous Status">{{ log.old_status | reviewStatus }}</md-table-cell>
              <md-table-cell md-label="Current Status">{{ log.new_status | reviewStatus }}</md-table-cell>
              <md-table-cell md-label="User">{{ log.user.name }} - {{ log.user.email }}</md-table-cell>
            </md-table-row>
          </md-table>
          <div
            :class="'md-flex text-center'"
            v-if="logs.length > 0">
            <Pagination
              :total="pagination.totalItems"
              :value="pagination.currentPage"
              :perPage="pagination.perPage"
              @input="changePage" />
          </div>
         <div
            :class="'md-flex text-center'"
            v-if="isFetching">
            <md-progress-spinner
              :class="'md-accent'"
              :md-stroke="3"
              md-mode="indeterminate"></md-progress-spinner>
          </div>
        </md-card-content>
        <md-card-actions md-alignment="left">
          <md-button :class="'md-default'" @click="$router.go(-1)">
            Back
          </md-button>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<script>
  import { SlideYDownTransition } from 'vue2-transitions'
  import { Pagination } from '@/components'
  import { reviewStatus, datetime } from '@/filters'
  import { camelToSnake } from "@/methods/api/requests";
  import * as utils from "@/utils";
  import * as filters from "@/filters";
  
  export default {
    components: {
      SlideYDownTransition,
      Pagination,
    },

    filters: {
      reviewStatus,
      datetime
    },

    data() {
      return {
        logs: [],
        isFetching: false,

        filter: {
          email: '',
        },

        pagination: {
          totalItems: '',
          currentPage: '',
          perPage: '',
        },

        errorResponses: {
          400: 'The logs spreadsheet is invalid',
          422: 'There is an error with your file',
        },
      }
    },

    computed: {
      currentProfile () {
        return this.$store.state.currentProfile
      },

      filtersQuery() {
        return filters.getFiltersQuery(this.filter);
      },

      paginationQuery() {
        return utils.getPaginationQuery(this.pagination.currentPage);
      },
    },

    methods: {
      goBack () {
        if (
          this.currentProfile !== 'admin' &&
          this.currentProfile !== 'rqr_leader' &&
          this.currentProfile !== 'reviewer')
        {
          this.$router.push({ name: 'Reviews' })
        }
      },

      getLogs() {
        this.isFetching = true

        this.$api.request(`logs?review_id=${this.$route.params.review_id}&${this.filtersQuery}${this.paginationQuery}`)
          .then(response => {
            this.logs = camelToSnake(response.data.data)

            this.pagination.totalItems = response.data.meta.total;
            this.pagination.currentPage = response.data.meta.currentPage;
            this.pagination.perPage = response.data.meta.perPage;
          })
          .finally(() => {
            this.isFetching = false
          })
      },

      changePage(toPage) {
        if(toPage === this.pagination.currentPage) {
          return
        }

        this.pagination.currentPage = toPage

        this.getLogs()
      },
    },

    watch: {
      currentProfile: function () {
        this.goBack()
      }
    },

    created() {
      this.goBack()
      this.getLogs()
    },
  }
</script>
